import React from "react";
import "../../assets/css/style.css";
import "./CSS/Enhanced.css";
import "./CSS/Medias.css";
import InvitationText from "../InvitationText";

class ModernMinimalist extends React.Component {
  constructor(props) {
    super(props);
    this.isSideBySide = props.isSideBySide;
  }

  render() {
    const bodyStyle = this.isSideBySide
      ? "body-style-regular-wedding"
      : "body-style-classic-wedding";
    return (
      <div id="fullCard" className="modernMinimalist-wedding">
        {this.props.isSideBySide && <div className="watermark"></div>}
        <div className={bodyStyle}>
          <InvitationText
            reqObject={this.props.reqObject}
            handleReqObject={this.handleReqObject}
            isSakura={false}
          />
        </div>
      </div>
    );
  }
}

export default ModernMinimalist;
